import {PayloadAction} from "@reduxjs/toolkit";
import {Dispatch} from "react";
import {StripeService} from "../service/Stripe/StripeService";
import {
    ConfirmPaymentSuccessRequest,
    PaymentRequest,
    PaymentResponse,
    RefundRequest,
    RefundResponse,
    PaymentListResponse,
    PaymentIntent
} from "../shared/entities/Stripe/Stripe";
import {Option} from "../shared/utilities/OptionT";

export class StripeController {
    private dispatch: Dispatch<PayloadAction<any>>
    private service: StripeService

    constructor(dispatch: Dispatch<PayloadAction<any>>) {
        this.dispatch = dispatch
        this.service = new StripeService(this.dispatch)
    }

    /**
     * Create a payment intent
     */
    public async createPaymentIntent(data: PaymentRequest): Promise<PaymentResponse> {
        return this.service.createPaymentIntent(data).then(res => {
            return res
        })
    }

    /**
     * Синхронизация успешной оплаты с БД (если webhook Stripe не пришёл).
     */
    public async confirmPaymentSuccess(data: ConfirmPaymentSuccessRequest): Promise<PaymentResponse> {
        return this.service.confirmPaymentSuccess(data).then(res => res)
    }

    /**
     * Get payment intent by ID
     */
    public async getPaymentIntent(id: string): Promise<PaymentIntent> {
        return this.service.getPaymentIntent(id).then(res => {
            return res
        })
    }

    /**
     * Create a refund
     */
    public async createRefund(data: RefundRequest): Promise<RefundResponse> {
        return this.service.createRefund(data).then(res => {
            return res
        })
    }

    /**
     * List payments with pagination
     */
    public async listPayments(limit: number = 10, startingAfter?: string, endingBefore?: string): Promise<PaymentListResponse> {
        return this.service.listPayments(limit, startingAfter, endingBefore).then(res => {
            return res
        })
    }

    /**
     * Get refunds for a specific payment
     */
    public async getRefundsForPayment(paymentIntentId: string): Promise<RefundResponse[]> {
        return this.service.getRefundsForPayment(paymentIntentId).then(res => {
            return res
        })
    }

    /**
     * Search payments by email
     */
    public async searchPaymentsByEmail(email: string, limit: number = 50): Promise<PaymentListResponse> {
        return this.service.searchPaymentsByEmail(email, limit).then(res => {
            return res
        })
    }

    /**
     * Clear payment data
     */
    public clearPaymentData(): void {
        this.service.clearPaymentData()
    }

    /**
     * Handle result with error checking
     */
    private static handleResult<T>(res: Option<T>): Option<boolean> {
        if (res?.None) {
            return {
                Some: false,
                None: res.None
            }
        }
        return {Some: true}
    }
}